import ImpactGridItems from "../../impact-token-marketplace/ImpactGridItems";
import ImpactListItems from "../../impact-token-marketplace/ImpactListItems";

const Collections = ({
  assetsList,
  viewMode = "grid",
  startIndex = 0,
  walletAddress = null,
}) => {
  return (
    <div className="tab-content">
      {viewMode === "grid" ? (
        /* Responsive Grid - Better for smaller laptops */
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          <ImpactGridItems assetsList={assetsList} />
        </div>
      ) : (
        /* Responsive List */
        <div className="w-full">
          {/* Desktop Table View */}
          <div className="hidden xl:block">
            <div className="w-full">
              <div
                role="table"
                className="w-full bg-white dark:bg-jacarta-800 text-sm dark:text-white rounded-xl shadow-sm border border-jacarta-100 dark:border-jacarta-600 overflow-hidden"
              >
                {/* Table Header */}
                <div
                  className="flex bg-jacarta-50 dark:bg-jacarta-700 rounded-t-xl border-b border-jacarta-100 dark:border-jacarta-600"
                  role="row"
                >
                  <div className="w-[35%] py-3 px-4" role="columnheader">
                    <span className="font-semibold text-jacarta-700 dark:text-white">
                      Impact Art
                    </span>
                  </div>
                  <div
                    className="w-[13%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Price
                    </span>
                  </div>
                  <div
                    className="w-[13%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Creator
                    </span>
                  </div>
                  <div
                    className="w-[13%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Views
                    </span>
                  </div>
                  <div
                    className="w-[13%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Action
                    </span>
                  </div>
                </div>

                {/* Table Body */}
                <ImpactListItems
                  assetsList={assetsList}
                  viewType="desktop"
                  startIndex={startIndex}
                  walletAddress={walletAddress}
                />
              </div>
            </div>
          </div>

          {/* Tablet Compact Table View */}
          <div className="hidden lg:block xl:hidden">
            <div className="scrollbar-custom overflow-x-auto">
              <div
                role="table"
                className="w-full min-w-[700px] bg-white dark:bg-jacarta-800 text-sm dark:text-white rounded-xl shadow-sm border border-jacarta-100 dark:border-jacarta-600"
              >
                {/* Compact Table Header */}
                <div
                  className="flex bg-jacarta-50 dark:bg-jacarta-700 rounded-t-xl border-b border-jacarta-100 dark:border-jacarta-600"
                  role="row"
                >
                  <div className="w-[45%] py-3 px-4" role="columnheader">
                    <span className="font-semibold text-jacarta-700 dark:text-white">
                      Impact Art
                    </span>
                  </div>
                  <div
                    className="w-[18%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Price
                    </span>
                  </div>
                  <div
                    className="w-[18%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Stats
                    </span>
                  </div>
                  <div
                    className="w-[19%] py-3 px-4 text-center"
                    role="columnheader"
                  >
                    <span className="font-semibold text-jacarta-700 dark:text-white text-center">
                      Action
                    </span>
                  </div>
                </div>

                {/* Compact Table Body */}
                <ImpactListItems
                  assetsList={assetsList}
                  viewType="tablet"
                  startIndex={startIndex}
                  walletAddress={walletAddress}
                />
              </div>
            </div>
          </div>

          {/* Mobile Card View */}
          <div className="block lg:hidden">
            <ImpactListItems
              assetsList={assetsList}
              viewType="mobile"
              startIndex={startIndex}
              walletAddress={walletAddress}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Collections;
